const Index = () => import(/* webpackChunkName: "proj" */ './Index');
const claimManage = () => import(/* webpackChunkName: "proj" */ './claimManage');
const claimCheck = () => import(/* webpackChunkName: "proj" */ './claimCheck');

export default {
  routes: [
    {
      path: '/proj/incoclaim/index',
      name: 'proj_incoclaim_index',
      component: Index
    },
    {
          path: '/proj/incoclaim/claimManage/:dbid',
          name: 'proj_incoclaim_claimManage',
          component: claimManage
      },
      {
          path: '/proj/incoclaim/claimCheck/:dbid',
          name: 'proj_incoclaim_claimCheck',
          component: claimCheck
      },
  ]
}
